// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
import packageJson from '../../package.json';
import { IEnvConfig } from './env-config.model';

export const environment: IEnvConfig = {
  production: false,
  stage: false,
  version: packageJson.version,

  // DEFAULT_CONFIG_NAME: 'core',
  DEFAULT_CONFIG_NAME: 'san-francisco', //  hopkinsandco  anton-mvp  <= Default for development
  // DEFAULT_CONFIG_NAME: 'hopkinsandco', //    anton-mvp
  // DEFAULT_CONFIG_NAME: 'devcluster',
  // DEFAULT_CONFIG_NAME: 'jpcentresouth',
  // DEFAULT_CONFIG_NAME: 'lexington',
  // DEFAULT_CONFIG_NAME: 'windham',
  // DEFAULT_CONFIG_NAME: 'three-squares',
  // DEFAULT_CONFIG_NAME: 'testing',

  // Prod
  // API_URL: 'https://api.brightrtravel.com/api/',
  // WLS_CONFIG_URL: '/',
  // MEDIA_API_URL: 'https://api.brightrtravel.com/media/',
  // MEDIA_API_URL_ORIGINAL: 'https://api.brightrtravel.com/media/volatile/emoji/original/',
  // MEDIA_API_URL_CIRCLE: 'https://api.brightrtravel.com/media/volatile/emoji/circle/',
  // MEDIA_API_URL_DISABLED: 'https://api.brightrtravel.com/media/volatile/emoji/disabled/',
  // MEDIA_API_URL_PINS: 'https://api.brightrtravel.com/media/volatile/emoji/pins/',

  // Dev
  API_URL: 'https://api-beacon-me-dev.fezr.com/api/',

  WLS_CONFIGS_URL: 'https://consumer-dev-beacon-me-dev.fezr.com/',
  MEDIA_API_URL: 'https://api-beacon-me-dev.fezr.com/media/',
  MEDIA_API_URL_ORIGINAL:
    'https://api-beacon-me-dev.fezr.com/media/volatile/emoji/original/',
  MEDIA_API_URL_CIRCLE:
    'https://api-beacon-me-dev.fezr.com/media/volatile/emoji/circle/',
  MEDIA_API_URL_DISABLED:
    'https://api-beacon-me-dev.fezr.com/media/volatile/emoji/disabled/',
  MEDIA_API_URL_PINS:
    'https://api-beacon-me-dev.fezr.com/media/volatile/emoji/pins/',

  GOOGLE_MAPS_API_KEY: 'AIzaSyBTaPM6zJPozc5hvbJJCwzOujvltbrJir4', // 'AIzaSyAa5LkchlJsycYShUhIpWBzrqz8heBVhX4',
  FACEBOOK_APP_ID: '1436092813330648',
  GOOGLE_ANALYTICS_KEY: 'UA-167101901-1', // my key for develop
  SENTRY_URL: 'https://17e8af87bd0c40898f7fdd2f8e479cb4@sentry.io/1302243',
  AMPLITUDE_API_KEY: '0c275324a12630f18d7da1045d00ad12',
  STRIPE_KEY:
    'pk_test_51HA13ILXmJJf0oWcPh07lXxyeZp7YdmGJQNKVqkDr4OeXxSYZ5cbRCtqB1NKHBVfKp2saPCT1OiQWuavrKqcwtDB006dfaXgBa',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
